import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

const TotalCommission = () => {
    const rows = useSelector((state) => state.orderPosition.positions, shallowEqual);
    const symbols = useSelector(state => state.watchlist.symbols, shallowEqual);
    const params = useSelector(state => state.symbol.allSymbolParams, shallowEqual);
    const updateSymbols = useSelector(state => state.updateSymbol.symbols, shallowEqual);

    const totalCommission = useMemo(() => {
        if (!rows || !symbols || !params) return 0;

        return rows.reduce((total, row) => {
            const { amount, side, symbolId } = row;
            const symbol = symbols?.[symbolId];
            const symbolParams = params?.[symbolId];
            const refSymbol = updateSymbols?.[symbol?.referenceSymbolId];

            if (!symbol || !symbolParams) return total;

            const { bid, ask, contractSize } = symbol;
            const { closeCommissionValue, closeCommissionType, referenceSymbolCalculationType } = symbolParams;
            const currentPrice = side === 1 ? bid : ask;

            const refValue =
                !symbol?.referenceSymbolId || !refSymbol
                    ? 1
                    : referenceSymbolCalculationType === 'Division'
                        ? 1 / currentPrice
                        : currentPrice;

            let commission = 0;
            switch (closeCommissionType) {
                case 1:
                    commission = amount * contractSize * currentPrice * 0.01 * closeCommissionValue * refValue;
                    break;
                case 2:
                    commission = closeCommissionValue * amount;
                    break;
                case 3:
                    commission = closeCommissionValue;
                    break;
                default:
                    commission = 0;
            }

            return total + commission;
        }, 0);
    }, [rows, symbols, params, updateSymbols]);


    return (
        <strong>{totalCommission.toFixed(2)}</strong>
    );
};

export default TotalCommission;
